import styles from './Waves.module.css';

// Three soft royal-blue sine waves drifting sideways (SPEC section 11). They
// stop under reduced motion and never sit behind text people need to read.
export function Waves({ tone = 'page' }: { tone?: 'page' | 'brand' }) {
  const paths = [
    'M0 60 C 150 20 350 100 500 60 S 850 20 1000 60 S 1350 100 1500 60 S 1850 20 2000 60 V 200 H 0 Z',
    'M0 90 C 180 50 320 130 500 90 S 820 50 1000 90 S 1320 130 1500 90 S 1820 50 2000 90 V 200 H 0 Z',
    'M0 120 C 160 90 340 150 500 120 S 840 90 1000 120 S 1340 150 1500 120 S 1840 90 2000 120 V 200 H 0 Z',
  ];
  return (
    <div className={`${styles.waves} ${tone === 'brand' ? styles.brand : ''}`} aria-hidden="true">
      {paths.map((d, index) => (
        <svg key={d} className={styles.layer} style={{ animationDuration: `${80 + index * 20}s`, bottom: 0 }} viewBox="0 0 2000 200" preserveAspectRatio="none">
          <path d={d} />
        </svg>
      ))}
    </div>
  );
}
